<div class="row no-gutters align-items-end">
  <div [ngClass]="singleMode ? 'col-md-9' : 'col-md-10'">
    <div class="row no-gutters">
      <!-- Input Inicio o Single -->
      <div [ngClass]="singleMode ? 'col-12' : 'col-6'" class="px-1">
        <label class="form-label mb-1">{{ labelInicio }}</label>
        <input [type]="mode" class="form-control" 
               [(ngModel)]="startDate" 
               (change)="updateValues()"
               [min]="minDate" 
               [max]="maxDate"
               [disabled]="IsDisabled || IsDisabledAll">
      </div>
      <!-- Input Fin (Solo Dual) -->
      <div class="col-6 px-1" *ngIf="!singleMode">
        <label class="form-label mb-1">{{ labelFin }}</label>
        <input [type]="mode" class="form-control" 
               [(ngModel)]="endDate" 
               (change)="updateValues()"
               [min]="minDate" 
               [max]="maxDate"
               [disabled]="IsDisabledEnd || IsDisabledAll">
      </div>
    </div>
  </div>

  <div class="col-md-2 px-1">
    <div class="btn-group w-100">
      <button type="button" class="btn btn-sm btn-custom-today" (click)="setToday()" title="Hoy">
        <i class="fa fa-calendar-check-o"></i>
        <span *ngIf="!isCompact" class="ml-1">Hoy</span>
      </button>
      <button type="button" class="btn btn-sm btn-outline-danger" (click)="resetFilters()" title="Limpiar">
        <i class="fa fa-trash"></i>
        <span *ngIf="!isCompact" class="ml-1">Limpiar</span>
      </button>
    </div>
  </div>

  <!-- Alerta de Error: Quitamos el !singleMode para que el modo único también muestre error de límites -->
  <div class="col-12 px-1">
    <div *ngIf="isInvalidRange" class="text-danger small font-weight-bold">
      <i class="fa fa-warning"></i> {{ errorMessage }}
    </div>
  </div>
</div>